import cx from 'classnames';

import classes from './FleetAircraftList.module.scss';

export interface FleetAircraft {
  id: number;
  aircraftName?: string | null;
  tail?: string | null;
  paxCapacity?: number | null;
  // A fleet is a member of its own fleet; that placeholder is not a real aircraft.
  isFleet?: boolean;
}

interface FleetAircraftListProps {
  aircraft: FleetAircraft[];
  emptyText?: string;
  onAircraftClick?: (aircraft: FleetAircraft) => void;
}

const FleetAircraftList = ({
  aircraft,
  emptyText = 'No aircraft assigned yet',
  onAircraftClick,
}: FleetAircraftListProps): JSX.Element => {
  const members = (aircraft ?? []).filter((item) => !item.isFleet);

  if (members.length === 0) {
    return <p className={classes.fleetAircraftEmpty}>{emptyText}</p>;
  }

  const clickable = Boolean(onAircraftClick);

  return (
    <div className={classes.fleetAircraftList}>
      {members.map((item) => (
        <div
          key={item.id}
          className={cx('entry', { clickable })}
          onClick={clickable ? () => onAircraftClick?.(item) : undefined}
          onKeyDown={
            clickable
              ? (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  onAircraftClick?.(item);
                }
              }
              : undefined
          }
          role={clickable ? 'button' : undefined}
          tabIndex={clickable ? 0 : undefined}
        >
          <span className="craft">{item.aircraftName || ' - '}</span>
          <span className="reg">{item.tail || ' - '}</span>
        </div>
      ))}
    </div>
  );
};

export default FleetAircraftList;
